import { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { useTranslation } from "react-i18next";
import "./locales/i18n";
import "./index.css";
import { Navbar } from "./components/StructuralComponents/Navbar";
import { Hero } from "./components/StructuralComponents/Hero";
import { AboutMe } from "./components/StructuralComponents/AboutMe";
import { LatestUpdates } from "./components/StructuralComponents/LatestUpdates";
import { Projects } from "./components/StructuralComponents/Projects";
import { Skills } from "./components/StructuralComponents/Skills";
import { Achieve } from "./components/StructuralComponents/Achieve";
import { Education } from "./components/StructuralComponents/Education";
import { Publication } from "./components/StructuralComponents/Publication";
import { Footer } from "./components/StructuralComponents/Footer";

//

export default function App() {
  const { i18n } = useTranslation();

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  useEffect(() => {
    document.documentElement.dir = i18n.language === "fa" ? "rtl" : "ltr";

    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  const { t } = useTranslation();
  return (
    <div className="page">
      <div className="fixed-background" />
      <div className="content">
        <Navbar t={t} changeLanguage={changeLanguage} />
        <Hero t={t} />
        <article className="mainArticle">
          <AboutMe t={t} />
          <LatestUpdates t={t} />
          <Projects t={t} />
          <Skills />
          <Achieve t={t} />
          <Education />
          <Publication />
        </article>
        <Footer />
      </div>
    </div>
  );
}
ReactDOM.createRoot(document.getElementById("root")).render(<App />);
